import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Link from 'gatsby-link'
import isEqual from 'lodash.isequal'

import ArrowRightIcon from '../../assets/icons/arrow-right-icon'
import './breadcrumbs.scss'

class BreadCrumbs extends React.Component {
  constructor(props) {
    super(props)
  }

  getCurrentPage() {
    const pathName = this.props.location.pathname
    const location = pathName.endsWith('/') ?  pathName.slice(0, -1) : pathName

    return location in this.props.pages ? this.props.pages[location] : null
  }

  render() {
    const { lang, localization } = this.props
    const currentPage = this.props.currentPage || this.getCurrentPage()
    const parent = this.props.parentPage || (currentPage && currentPage.parent ? currentPage.parent : null)

    const parentPage = parent ? 
      <span>
        <Link to={ `${parent.path}` }>{ `${parent.title}` }</Link>
        <ArrowRightIcon className="icon"/>
      </span> : null

    return (
      <div className="breadcrumbs-container">
        <span>
          <Link to={ `/${lang}` }>{ localization('global.home') }</Link>
        </span>
        <span>
          <ArrowRightIcon className="icon"/>
        </span>
        { parentPage }
        <span className="current-page">
          { currentPage ? currentPage.title : '' }
        </span>
      </div>
    )
  }
}


const mapStateToProps = ({ pages }) => {
  return { pages }
}

const RoutedBreadCrumbs = withRouter(BreadCrumbs)
const ConnectedBreadCrumbs = connect(
  mapStateToProps
)(RoutedBreadCrumbs)


export default ConnectedBreadCrumbs


// WEBPACK FOOTER //
// ./src/components/BreadCrumbs/breadcrumbs.js